import { Dispatch, SetStateAction, useState } from 'react';
// useLayoutEffect
import { Outlet, useLoaderData } from 'react-router-dom';

import type { LiteGenerationGroup } from 'src/api/models';

export interface ContainerOutletContext {
  optimizerLiteContext: OptimizerLiteContext;
  setOptimizerLiteContext: Dispatch<SetStateAction<OptimizerLiteContext>>;
}
export interface OptimizerLiteContext {
  liteGenerationGroup: LiteGenerationGroup;
}
export function AdminContainer() {
  const optimizerLiteContextFromLoader = useLoaderData() as OptimizerLiteContext;
  const [optimizerLiteContext, setOptimizerLiteContext] = useState(optimizerLiteContextFromLoader);

  return (
    <div
      id='main-content'
      className='fixed size-full min-h-dvh overflow-hidden bg-[url("https://storage.googleapis.com/mavid-311321.appspot.com/maverick-brand-assets/optimizer-lite-bg-blue-pink-new.webp")] bg-cover bg-center bg-no-repeat p-3'
    >
      <main className='size-full'>
        <Outlet
          context={{
            optimizerLiteContext: optimizerLiteContext,
            setOptimizerLiteContext: setOptimizerLiteContext,
          }}
        />
      </main>
    </div>
  );
}
